import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { MatInput } from '@angular/material/input';
import { MatSuffix } from '@angular/material/form-field';
import { MatSlideToggle } from '@angular/material/slide-toggle';

export interface RoadmapExportDialogData {
  from: Date;
  to: Date;
  is_epics_request: boolean;
}

@Component({
  selector: 'app-roadmap-export-dialog',
  templateUrl: './roadmap-export-dialog.component.html',
  styleUrl: './roadmap-export-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatFormField,
    MatLabel,
    MatInput,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatDatepicker,
    MatSuffix,
    MatButton,
    MatSlideToggle,
  ],
})
export class RoadmapExportDialogComponent {
  private fb = inject(FormBuilder);
  private dialogRef = inject<MatDialogRef<RoadmapExportDialogComponent>>(MatDialogRef);
  data = inject<RoadmapExportDialogData>(MAT_DIALOG_DATA);

  formGroup = this.fb.group({
    from: [this.data.from, Validators.required],
    to: [this.data.to, Validators.required],
    is_epics_request: [this.data.is_epics_request],
  });

  submit(): void {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
      return;
    }

    const formValue = this.formGroup.getRawValue();
    this.dialogRef.close({
      from: formValue.from!,
      to: formValue.to!,
      is_epics_request: formValue.is_epics_request ?? false,
    } as RoadmapExportDialogData);
  }

  close(): void {
    this.dialogRef.close();
  }
}
